<template>
  <div class="enroll-student-upload-no-photo">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDrawer :visible.sync="visible">
      <div class="enroll-photo-upload-no-photo-popper">
        <TemplateDataGrid ref="grid"
                          gridId="PeEnrollNoPhotoStudent"></TemplateDataGrid>
      </div>
    </DataGridDrawer>
  </div>
</template>

<script>
import DataGridDrawer from '../../../../../../../elements/grid/DataGridDrawer'
import TemplateDataGrid from '../../../../../../../templates/TemplateDataGrid'
export default {
  name: 'EnrollStudentUploadNoPhoto',
  components: {
    DataGridDrawer,
    TemplateDataGrid
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    reloadGridData () {
      this.$nextTick(() => {
        let grid = this.$refs.grid
        if (grid) {
          grid.loadGridData()
        }
      })
    }
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.reloadGridData()
      }
    }
  }
}
</script>

<style lang="scss">
  .enroll-student-upload-no-photo {
    display: inline-block;
  }
  .enroll-photo-upload-no-photo-popper {
    width: 1000px;
    max-width: 100%;
    height: 100%;
  }
</style>
